export default "__VITE_ASSET__D$0DYYvC__"